module.exports = __webpack_public_path__ + "img/kt5.ae3d1299.png";